import { __rest, __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Box, Tooltip as Tooltip$1 } from '@chakra-ui/react';
import CheckFilled from '../icons/CheckFilled.js';

var Tooltip = function (_a) {
    var label = _a.label, placement = _a.placement, hasIcon = _a.hasIcon, _b = _a.icon, icon = _b === void 0 ? React.createElement(CheckFilled, { width: "12px", height: "12px", color: "success.300", mr: 2 }) : _b, children = _a.children, _c = _a.textAlign, textAlign = _c === void 0 ? "left" : _c, _d = _a.trigger, trigger = _d === void 0 ? "hover" : _d, args = __rest(_a, ["label", "placement", "hasIcon", "icon", "children", "textAlign", "trigger"]);
    var _e = useState(false), isOpen = _e[0], setIsOpen = _e[1];
    var triggerRef = useRef(null);
    var handleToggle = useCallback(function (e) {
        e.stopPropagation();
        setIsOpen(function (prev) { return !prev; });
    }, []);
    useEffect(function () {
        if (trigger !== "click" || !isOpen)
            return;
        var handleOutsideClick = function (e) {
            if (triggerRef.current && !triggerRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("pointerdown", handleOutsideClick);
        return function () { return document.removeEventListener("pointerdown", handleOutsideClick); };
    }, [trigger, isOpen]);
    var labelContainer = (React.createElement(Box, { display: "flex", alignItems: "center" },
        hasIcon ? icon : null,
        " ",
        label));
    var clickProps = trigger === "click"
        ? { isOpen: isOpen }
        : {};
    return (React.createElement(Tooltip$1, __assign({ hasArrow: true, arrowSize: 12, label: labelContainer, placement: placement, textAlign: textAlign, sx: {
            p: 3,
        } }, args, clickProps), trigger === "click" ? (React.createElement(Box, { ref: triggerRef, display: "inline-flex", onClick: handleToggle }, children)) : (children)));
};

export { Tooltip as default };
//# sourceMappingURL=Tooltip.js.map
